var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-page-header',{staticClass:"page-header",on:{"back":function($event){return _vm.$router.go(-1)}}},[(_vm.headerTitle)?_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.headerTitle))]):_vm._e(),_vm._t("subheader"),_c('template',{slot:"extra"},[_vm._t("buttons")],2),_vm._t("other")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }